<template>
  <article class="flex flex-col space-y-4" role="article">
    <div class="relative">
      <a
        :aria-label="`View ${partner.name} partner`"
        target="_blank"
        rel="noopener noreferrer"
        class="block"
        :href="partner.url"
      >
        <figure class="figure" role="figure">
          <img
            :alt="partner.bannerAlt"
            loading="lazy"
            class="bg-secondary-100 aspect-3/2 object-cover object-center w-full h-full"
            :src="partner.bannerImage"
          />
        </figure>
      </a>
      <div class="absolute bottom-0 right-6 z-20 size-16 translate-y-4">
        <a
          :aria-label="`View ${partner.name} partner`"
          target="_blank"
          rel="noopener noreferrer"
          class="block"
          :href="partner.url"
        >
          <figure class="figure" role="figure">
            <img
              :alt="partner.logoAlt"
              loading="lazy"
              class="bg-secondary-100 aspect-square object-cover object-center w-full h-full"
              :src="partner.logoImage"
            />
          </figure>
        </a>
      </div>
    </div>
    <div class="space-y-3 @tablet:max-w-[75%]">
      <header class="space-y-3">
        <div v-if="partner.categories?.length">
          <span
            v-for="(cat, i) in partner.categories"
            :key="i"
            class="text-body-xs font-semibold tracking-wide text-primary"
          >
            {{ cat }}{{ i < partner.categories.length - 1 ? ', ' : '' }}
          </span>
        </div>
        <a
          :aria-label="`View ${partner.name} partner`"
          target="_blank"
          rel="noopener noreferrer"
          class="block"
          :href="partner.url"
        >
          <h4 class="font-heading text-h4 tablet:text-h4-tablet laptop:text-h4-desktop font-bold @tablet:tablet:text-h3-tablet @tablet-landscape:laptop:text-h2-desktop">
            {{ partner.name }}
          </h4>
        </a>
        <div v-if="partner.regions?.length">
          <span
            v-for="(region, i) in partner.regions"
            :key="i"
            class="text-body-xs font-semibold tracking-wide text-primary"
          >
            {{ region }}{{ i < partner.regions.length - 1 ? ', ' : '' }}
          </span>
        </div>
      </header>
      <div v-if="partner.description">
        <p class="text-[15px] @tablet:text-body-md">
          {{ partner.description }}
        </p>
      </div>
      <div class="flex gap-3">
        <a
          v-if="partner.email"
          :href="`mailto:${partner.email}`"
          class="size-5 text-primary"
          aria-label="Email"
        >
          <EnvelopeIcon class="h-full w-full" />
        </a>
        <a
          v-if="partner.phone"
          :href="`tel:${partner.phone}`"
          class="size-5 text-primary"
          aria-label="Phone"
        >
          <PhoneIcon class="h-full w-full" />
        </a>
      </div>
      <a
        v-if="partner.website"
        class="block text-body-xs font-bold tracking-wide"
        target="_blank"
        rel="noopener noreferrer"
        :href="partner.url"
      >
        {{ partner.website }}
      </a>
    </div>
  </article>
</template>

<script setup>
import { EnvelopeIcon, PhoneIcon } from '@heroicons/vue/24/outline'

defineProps({
  partner: {
    type: Object,
    required: true
  }
})
</script>
